import React, { useState } from 'react'
import Select from 'react-select'
import { usePet, useToggle } from '../../modules'

import Modal from "../resusable/modal"

const NewStation = ({ toggle, visible, onPerform }) => {
    const [name, setName] = useState()
    const [major, setMajor] = useState()

    const onComplete = ({ }, notif, ops) => {
        onPerform()
        notif('Station has been added', ops('success'))

        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('newStation', {
        name,
        major: major?.value
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Adding station...' } })

    let majors = ['Sale of Items', 'Services']

    return (
        <Modal
            h="h-auto"
            w="w-3/4 sm:w-1/2 md:w-2/5 lg:w-1/3 xl:w-1/4"
            title="New Station"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap mb-6">
                <div className="w-full px-3 mt-4 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Station Name
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-name"
                        type="text"
                        onChange={e => setName(e.target.value)}
                        placeholder="Station Name" />
                </div>
                <div className="w-full px-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        What will be majorly done here?
                    </label>
                    <Select
                        value={major}
                        onChange={setMajor}
                        options={majors.map(major => ({ label: major, value: major }))}
                        placeholder="Select Major Activity" />
                </div>
            </div>
            <div className="flex mt-6 justify-end">
                <button disabled={loading} onClick={execute} type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default NewStation